module.exports = __webpack_public_path__ + "img/qr-code-1.59921e18.png";